export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.name'
  }),
  intl.formatMessage({
    id: 'table.country'
  })
]

export const line = (data = []) =>
  data.map(item => {
    return {
      line: [item.globalId || item.id, item.name, item.country.name]
    }
  })
